import styled from "styled-components"
import { Shadows } from "../../shadows"
import { SmallContainer } from "../../styles"

export const HoverContainer = styled(SmallContainer)<{ alignBottom?: boolean }>`
	position: absolute;
	left: -4px;
	right: -4px;
	border-radius: ${(props) =>
		props.alignBottom ? "20px 20px 0px 20px " : "20px 0px 20px 20px "};
	top: ${(props) => (props.alignBottom ? "unset" : "30px")};
	bottom: ${(props) => (props.alignBottom ? "30px" : "unset")};
	z-index: 10;
	pointer-events: none;
	transition: all 0.2s ease;
	box-shadow: ${Shadows.highlighted};
	background-color: white;

	&:before {
		content: "";
		position: absolute;
		top: 0;
		right: 0px;
		width: 0;
		height: 0;
		border: 12px solid transparent;
		border-bottom-color: white;
		border-top: 0;
		margin-left: -12px;
		margin-top: -12px;
		display: ${(props) => (props.alignBottom ? "none" : "block")};
	}

	&:after {
		content: "";
		position: absolute;
		bottom: 0;
		right: 0px;
		width: 0;
		height: 0;
		border: 12px solid transparent;
		border-top-color: white;
		border-bottom: 0;
		margin-left: -12px;
		margin-bottom: -12px;
		display: ${(props) => (props.alignBottom ? "block" : "none")};
	}
`
